import { render, staticRenderFns } from "./finances.vue?vue&type=template&id=061328b8&"
import script from "./finances.ts?vue&type=script&lang=js&"
export * from "./finances.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports